export const LANDING_PAGE_URL =
  import.meta.env.VITE_LANDING_PAGE_URL || 'https://signup.mezzapay.com'
